export default __webpack_public_path__ + "assets/images/48995b39fde68818aae7ab10551af7ca.png";